<!--季度产量-->
<template>
<div class="kee commonborder flex_row">
  <div id="ps_bar1" class="echarts"></div>
</div>

</template>

<script>
let echarts = require("echarts/lib/echarts");
import api from '@/apis/ProductionSystem'
export default {
  data() {
    return {
      //季度产量
      productionData:[
        [],
        [],
        [],
      ],

    };
  },
  methods: {

    ps_bar1(){
      let ps_bar1 = echarts.init(document.getElementById('ps_bar1') );
      ps_bar1.setOption({
          color:['#3570ff','#24ffb1'],
          tooltip: {
            trigger: 'axis',textStyle:{fontSize: this.$echartsFontSize},
            axisPointer: {
                type: 'shadow'
            }
          },
          legend: {
              data: ['指标', '实际'],
              right: 'center', top:8,
              textStyle: {
                  color: "#fff",fontSize:this.$echartsFontSize
              },
              itemWidth: 15,itemHeight: 5,
          },
          grid: {
            top: "30px", bottom: "10px", left:'120px',
            containLabel: false,
          },
          xAxis: {
            type: "value",show: false,
          },
          yAxis: {
            type: "category", show:true,axisLine:{show:false},splitLine:{show:false},
            axisLabel:{color:'#fff',fontSize:this.$echartsFontSize},axisTick: { show: false, },
            data: this.productionData[0],//['产品5','产品4','产品3','产品2','产品1'],
          },
          series: [
            {
              name: "指标",
              type: "bar",
              barWidth: "20%",
              itemStyle: {
                normal: { 
                  label: { show: true,
                    position:'right', formatter: ' {c}',color:'#ccd0f2',fontSize:this.$echartsFontSize,
                  },
                }
              },
              data: this.productionData[1],//[600,600,600,100,600],
            },
            {
              name: "实际",
              type: "bar",
              barWidth: "20%",barGap:'-100%',
              itemStyle: {
                normal: { 
                  label: { show: true, 
                    position:'insideRight', formatter: '{c}',color:'#0a1d91',fontSize:this.$echartsFontSize,
                    offset:[0,1],fontWeight:600
                  },
                }
              },
              data: this.productionData[2]//[90,190,190,390,490],
            },
          ],
      })
    },



  },
  mounted() {

        //季度产量

      api
        .production({
          params: {
            limit: 100,
            page: 1,
          },
        })
        .then((res) => {
          if (res.code === 10000) {
            if (res.data.list.length) {
              let datalist = res.data.list

              for (const iterator of datalist) {
                this.productionData[0].push(iterator.proName)
                this.productionData[1].push(iterator.proData)
                this.productionData[2].push(iterator.proTarget)

              }
              this.ps_bar1();
            }
          } else {
            this.$message.error(res.message)
          }
        })

  },
};
</script>

<style lang="less" scoped>
.kee{
  #Quarter_bar1{ height: 100%; width: 65%;}
  
}
.flex_row{
    justify-content: flex-start;
}
</style>